<div class="modal-body" [attr.data-role]="'modal-body'" [id]="bodyId" [attr.tabIndex]="scrollable ? '0' : null">
  @if (customModalBody) {
    <ng-container *ngTemplateOutlet="customModalBody?.templateRef; context: hostRef"> </ng-container>
  } @else {
    Custom Body
  }
</div>
